import { Route, Routes } from "react-router";

import { LoginPage } from "@/features/auth/ui/login-page";
import { CatalogPage } from "@/features/card/ui/catalog-page";
import { CheckPage } from "@/features/card/ui/check-page";

export function AppRouter() {
	return (
		<Routes>
			<Route path="/login" element={<LoginPage />} />
			<Route path="/:code/rewards" element={<CatalogPage />} />
			<Route path="/:code" element={<CheckPage />} />
			<Route path="/" element={<CheckPage />} />
			<Route path="*" element={<CheckPage />} />
		</Routes>
	);
}
